import { DEFAULT_THEME, createTheme, virtualColor } from '@mantine/core'
import { inter } from './fonts'

export const theme = createTheme({
  primaryColor: 'primary',
  defaultRadius: 'sm',
  cursorType: 'pointer',
  autoContrast: true,
  fontFamily: inter.style.fontFamily,
  fontFamilyMonospace: inter.style.fontFamily,
  headings: {
    fontFamily: `${inter.style.fontFamily}, ${DEFAULT_THEME.fontFamily}`,
    fontWeight: 'bold',
  },
  white: '#fff',
  black: '#1f1f1f',
  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '76em',
    xl: '91em',
  },
  colors: {
    primary: virtualColor({
      name: 'primary',
      dark: 'main',
      light: 'secondary',
    }),

    main: [
      '#9fa8b2',
      '#6f7d8b',
      '#49525b',
      '#212529',
      '#1b1f22',
      '#2C3137',
      '#171A1E',
      '#22262B',
      '#212529',
      '#464F59',
      '#2C3137',
    ],
    secondary: [
      '#f2f0ff',
      '#e0dff2',
      '#bfbdde',
      '#9b98ca',
      '#7d79ba',
      '#6a65b0',
      '#605bac',
      '#504c97',
      '#464388',
      '#3b3979',
    ],

    dark: [
      '#cfd4d8',
      '#9fa8b2',
      '#6f7d8b',
      '#49525b',
      '#212529',
      '#1b1f22',
      '#141719',
      '#171A1E',
      '#22262B',
      '#212529',
      '#464F59',
      '#2C3137',
      '#2B333A',
      '#2C3238',
      '#6B7583',
      '#22262B',
      '#6E7780',
      '#22262A',
    ],

    prime: [
      '#DBFE02',
      '#A7F600',
      '#7DEE00',
      '#00C800',
      '#00A800',
      '#008000',
      '#006400',
      '#004800',
      '#2CEA65',
      '#44FF66',
      '#00A800',
      '#B9C7D4',
      '#3C8AFF',
      '#586572',
      '#C6802E',
      '#FF5177',
    ],
  },
})
